import { render, staticRenderFns } from "./CardGoodFood.vue?vue&type=template&id=0f93d88d&"
import script from "./CardGoodFood.vue?vue&type=script&lang=js&"
export * from "./CardGoodFood.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports